import React from "react";
import { View, Pressable, Text, StyleSheet } from "react-native";
import { getAllTags } from "./utils";
import { TagsContainerProps, TagProps } from "./interfaces";
import analytics from "@services/analytics";
import { MAP_VIEW_EVENTS } from "@constants/analyticsEventsCT";

const Tag = ({ tag, value, selectedType, onPress }: TagProps) => (
  <Pressable
    key={tag}
    style={[
      styles.tagButton,
      ...(selectedType === tag ? [{ borderColor: value.color.border }] : []),
    ]}
    onPress={() => onPress(tag)}
  >
    <Text
      style={[
        styles.tagCount,
        ...(selectedType === tag ? [{ color: value.color.text }] : []),
      ]}
    >
      {value.count}{" "}
    </Text>
    <Text style={styles.tagText}>{value.text}</Text>
  </Pressable>
);

const TagsContainer = ({
  markers,
  selectedType,
  setSelectedType,
  slideOut,
}: TagsContainerProps) => {
  const tags = getAllTags(markers);

  const handlePress = (tag: string) => {
    setSelectedType(tag);
    slideOut();
    analytics.trackEvent(MAP_VIEW_EVENTS.MAP_TAG_PRESS, { tag });
  };

  return tags.map((tag) => (
    <Tag
      key={tag.key}
      tag={tag.key}
      value={tag}
      selectedType={selectedType}
      onPress={handlePress}
    />
  ));
};

export default TagsContainer;

const styles = StyleSheet.create({
  tagButton: {
    flexDirection: "row",
    top: 10,
    marginLeft: 10,
    paddingVertical: 8,
    paddingHorizontal: 10,
    backgroundColor: "white",
    elevation: 5,
    borderRadius: 50,
    borderWidth: 2,
    borderColor: "white",
  },
  tagCount: {
    fontSize: 14,
    fontWeight: "bold",
  },
  tagText: {
    fontSize: 14,
  },
});
